export default function(form, selector) {
    form.init({
        target        : selector,
        successMessage: true
    });

    form.createInput({
        target: selector.querySelector('.j-input-email'),
        mode  : 'email',
        error : 'Email указан неверно'
    });
}
